<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-65">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                </div>
                                <h4 class="title">Modification d'un plan</h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                                <div class="flex items-center justify-end header-actions">
                                    <div class="mr-3">
                                        <md-button class="md-icon-button md-raised md-warning" @click="openEditPanel">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Modifier</md-tooltip>
                                    </div>
                                    <plan-button-pdf class="mr-3" :data="plan"></plan-button-pdf>
                                    <div>
                                        <md-button class="md-icon-button md-raised md-info" @click="fullScreen = true">
                                            <font-awesome-icon class="md-icon" :icon="['fas', 'expand']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Voir en plein écran</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <plan-view :plan="plan" :selectedDevice="selectedDevice" @clicked="handlePositions"></plan-view>
                        <md-dialog :md-active.sync="fullScreen" class="dialog-plan">
                            <plan-view :plan="plan" :selectedDevice="selectedDevice" @clicked="handlePositions"></plan-view>
                        </md-dialog>
                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-size-35">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'cogs']" />
                                </div>
                                <h4 class="title">Actions sur le plan</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-33">
                                <md-radio v-model="action" value="devices">Dispositifs</md-radio>
                            </div>
                            <div class="md-layout-item md-size-33">
                                <md-radio v-model="action" value="legend">Légende</md-radio>
                            </div>
                            <div class="md-layout-item md-size-33">
                                <md-radio v-model="action" value="date">Date</md-radio>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card style="margin-top: 40px;">
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'cog']" />
                                </div>
                                <h4 class="title">Liste des dispositifs</h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                                <div class="flex items-center justify-end header-actions">
                                    <div>
                                        <md-button class="md-icon-button md-raised md-warning"
                                                   @mousedown="goToRoute($event,'Site Devices Edit')">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Gérer les dispositifs</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="tabs-layout -mt-1.5">
                            <md-tabs @md-changed="changeTab" md-active-tab="tab-placed">
                                <md-tab class="h-full" v-for="tab in tabs" :key="tab.id" :id="tab.id" :md-label="tab.title">
                                    <plan-devices-tab :id="tab.id" :planId="plan.id" :site="plan.site"
                                                      :devices="plan.devices" :selectedDevice="selectedDevice"
                                                      @selectDevice="selectDevice"></plan-devices-tab>
                                </md-tab>
                            </md-tabs>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
        <md-drawer class="drawer-form" md-right md-fixed :md-active.sync="showEditPanel">
            <plan-edit-panel :plan="plan" @close="closeEditPanel"></plan-edit-panel>
        </md-drawer>
    </div>
</template>

<script>
// Components
import PlanView from "@/pages/Sites/Devices/Plans/components/PlanView";
import PlanDevicesTab from "@/pages/Sites/Devices/Plans/components/PlanDevicesTab";
import PlanButtonPdf from "@/pages/Sites/Devices/Plans/components/PlanButtonPdf";
import PlanEditPanel from "@/pages/Sites/Devices/Plans/components/PlanEditPanel";

// Mixins
import routerMixin from "@/mixins/router-mixin";

export default {
    name: "PlanEdit",
    components: {
        PlanView, PlanDevicesTab, PlanButtonPdf, PlanEditPanel
    },
	mixins: [routerMixin],
    data() {
        return {
            plan: {
                name: '',
                devices: [],
                site: {
                    devices: []
                }
            },
            action: null,
            selectedDevice: null,
            placements: [
                { value: 1, label: 'Gauche' },
                { value: 2, label: 'Haut' },
                { value: 3, label: 'Droite' },
                { value: 4, label: 'Bas' },
            ],
            fullScreen: false,
            tabs: [
                { id: 'tab-placed', title: 'Placés', active: true },
                { id: 'tab-remnants', title: 'Disponibles', active: false },
            ],
            showEditPanel: false,
        }
    },
    methods: {
        async getPlanDetails() {
            const { data } = await this.$store.dispatch('site_documents/getPlanDetails', {
                documentId: this.$route.params.documentId
            })
            data.devices.map(device => {
                device.plan_num = this.placements.find(placement => placement.value === device.plan_num)
                if(this.selectedDevice && device.id === this.selectedDevice.id) {
                    this.selectedDevice = device
                }
            })
            this.plan = data
        },
        async updatePlanPositions() {
            try {
                await this.$store.dispatch('site_documents/updatePlanPositions', {
                    documentId: this.plan.id,
                    plan_legend_x: this.plan.plan_legend_x ?? 0,
                    plan_legend_y: this.plan.plan_legend_y ?? 0,
                    plan_date_x: this.plan.plan_date_x ?? 0,
                    plan_date_y: this.plan.plan_date_y ?? 0,
                })
                await this.getPlanDetails()
            } catch (e) {}
        },
        async updateDevicePosition(x, y) {
            if(this.selectedDevice) {
				// If device already on this plan, search in plan devices, otherwise search in site devices
				const devices = (this.selectedDevice.plan_id !== null && this.selectedDevice.plan_id === this.plan.id) ? this.plan.devices : this.plan.site.devices
				const device = devices.find(device => device.id === this.selectedDevice.id)
				device.plan_x = x
				device.plan_y = y

                try {
                    await this.$store.dispatch('devices/updateDevicePlanPositions', {
                        deviceId: this.selectedDevice.id,
                        plan_id: this.plan.id,
                        plan_x: x,
                        plan_y: y
                    })
                    await this.getPlanDetails()
                } catch (e) {
					device.plan_x = this.selectedDevice.plan_x
					device.plan_y = this.selectedDevice.plan_y
				}
            }
        },
        handlePositions(positions) {
            const { offsetX, offsetY } = positions
			switch(this.action) {
				case 'legend':
					this.plan.plan_legend_x = offsetX
					this.plan.plan_legend_y = offsetY
					this.updatePlanPositions()
					break
				case 'date':
					this.plan.plan_date_x = offsetX
					this.plan.plan_date_y = offsetY
					this.updatePlanPositions()
					break
				default:
					let x = offsetX - 6
					let y = offsetY - 7
					this.updateDevicePosition(x, y)
					break
			}
        },
        selectDevice(e) {
            this.action = 'devices'
            this.selectedDevice = this.plan.site.devices.find(device => device.id === e.deviceId)
        },
        changeTab(id = 'tab-placed') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            if (activeTab) activeTab.active = true
        },
        openEditPanel() {
            this.showEditPanel = true
        },
        closeEditPanel() {
            this.showEditPanel = false
        },
    },
    mounted() {
		bus.$emit('minimise-sidebar')

	    this.getPlanDetails()
    },
    created() {
        bus.$on(['device-plan-removed', 'plan-updated'], () => {
            this.selectedDevice = null
            this.getPlanDetails()
        })
    },
    watch: {
        action(newVal) {
            if(newVal !== 'devices') {
                this.selectedDevice = null
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-table {
        &.md-table-devices {
            thead tr th:first-child,
            tbody tr td:first-child {
                padding-left: 0;
            }
            .md-table-cell {
                max-height: 35px;
                height: 35px;
                img {
                    max-width: 20px;
                }
            }
        }
    }
}
</style>
